import React from "react";
import { Button, Col, Row, Typography } from "antd";
import { LeftOutlined, UndoOutlined } from "@ant-design/icons";
import { Link, useNavigate } from "react-router-dom";
import error404Background from "./error404Background.png";
import shape1 from "./shape1.png";
import shape2 from "./shape2.png";
import shape3 from "./shape3.png";
import { css } from "@emotion/css";
import { useSelector } from "react-redux";
import SyncIcon from "../../../Theme/CustomIcons/Icons/Arrow/SyncIcon";
import ArrowBackIcon from "../../../Theme/CustomIcons/Icons/Arrow/ArrowBackIcon";
import MoreEmptyState from "../../../Theme/EmptyStates/MoreEmptyStates/MoreEmptyState";
// import NoConnection from "../../../Icons/NoConnection";
// import PageReload from "../../../Icons/PageReload";

const { Text } = Typography;
function ErrorNoConnection({ userType }) {
  const navigate = useNavigate();
  const themeDefault = useSelector((state) => state.themeDefault);
  const backToHomePage = () => {
    if (userType === "admin") {
      navigate("/admin/dashboard", { replace: true });
    } else if (userType === "user") {
      navigate("/user/dashboard", { replace: true });
    } else if (userType === "manager") {
      navigate("/manager/dashboard", { replace: true });
    } else {
      navigate("/login", { replace: true });
    }
  };
  const refreshPage = () => {
    window.location.reload();
  };

  return (
    <div
      className={css`
        // background-image: url(/pics/Dashboard/Dashboard-purple.png) !important;
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center;
        background-attachment: fixed;
        height: 100vh;
        overflow-y: auto;
      `}
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        // height: "100vh",
        // // backgroundColor: "#260A2F",
        // // backgroundImage: `url(${error404Background})`,
        // backgroundSize: "cover",
        // color: "white",
        textAlign: "center",
      }}
    >
      {/* Shapes */}
      <img
        src={shape1}
        alt="Shape 1"
        style={{
          // opacity: ".16",
          position: "absolute",
          top: "10%",
          right: "0",
          maxWidth: "200px",
        }}
      />
      <img
        src={shape2}
        alt="Shape 2"
        style={{
          // opacity: ".16",
          position: "absolute",
          left: "0%",
          top: "0%",
          maxWidth: "450px",
        }}
      />
      <img
        src={shape3}
        alt="Shape 3"
        style={{
          // opacity: ".16",
          position: "absolute",
          bottom: "0",
          left: "10%",
          maxWidth: "550px",
        }}
      />
      <Row
        className={css`
          display: flex;
          align-items: center;
          justify-content: center;
        `}
      >
        {" "}
        <MoreEmptyState type="ConnectionState" size="large" />
        {/* <Text
          style={{
            fontSize: "clamp(80px, 8vw,120px)",
            fontWeight: "bold",
            color: themeDefault?.info?.colorPrimary,
          }}
        >
          404
        </Text> */}
        {/* <Col span={24}> </Col> */}
        <Col span={24}>
          {" "}
          <div
            style={{
              display: "flex",
              gap: "15px",
              flexDirection: "column",
            }}
          >
            <Text
              style={{
                fontSize: "clamp(16px, 2vw, 24px)",
                fontWeight: "bold",
              }}
            >
              No Internet
            </Text>
            <Text>Sorry, You are not connected to the internet</Text>
          </div>
        </Col>
        <Col
          span={24}
          style={{
            display: "flex",
            marginTop: "15px",
            gap: "10px",
            justifyContent: "center",
          }}
        >
          <Button
            onClick={backToHomePage}
            icon={<ArrowBackIcon size="small" />}
            type="primary"
          >
            Back to Home
          </Button>
          <Button
            className={css`
              display: flex;
              gap: 10px !important;
            `}
            onClick={refreshPage}
          >
            Refresh
            <SyncIcon size="small" />
          </Button>
        </Col>
      </Row>
    </div>
  );
}

export default ErrorNoConnection;
